module.exports = __webpack_public_path__ + "static/media/Gnar.e9c55379.png";